import { useEffect, useEffectEvent, useRef } from 'react';

export const useOnOpen = (open: boolean, onOpen: () => void) => {
  const prevOpenRef = useRef(open);
  const stableOnOpen = useEffectEvent(onOpen);

  useEffect(() => {
    if (open && !prevOpenRef.current) {
      stableOnOpen();
    }
    prevOpenRef.current = open;
  }, [open]);
};

export const useOnClose = (open: boolean, onClose: () => void) => {
  const prevOpenRef = useRef(open);
  const stableOnClose = useEffectEvent(onClose);

  useEffect(() => {
    if (!open && prevOpenRef.current) {
      stableOnClose();
    }
    prevOpenRef.current = open;
  }, [open]);
};
